<template>
	<div>
		<form-sidebar>
			<v-form>
				<v-layout wrap>
					<v-flex xs12>
						<BaseSelect
							label="Periodo Contable"
							item-text="code"
							item-value="id"
							:height="38"
							:items="periods"
							v-model="periodId"
						/>
					</v-flex>
				</v-layout>
				<section class="modal-filter-footer">
					<modal-sidebar-button
						success-text="Aceptar"
						@cancel-button-clicked="$emit('on-close')"
						@accept-button-clicked="submitForm"
						:is-loading="disabled"
					></modal-sidebar-button>
				</section>
			</v-form>
		</form-sidebar>
	</div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

function created() {
	this.loadPeriods();
}

function disabled() {
	return this.$v.$invalid || this.loading;
}

async function loadPeriods() {
	const params = { subsidiaryId: this.subsidiaryId };
	({ data: this.periods } = await this.$http.get('period-con', { params }));
}

async function submitForm() {
	this.loading = true;
	let message = '';
	if (this.code === 'active') {
		message = 'activado';
	} else {
		message = this.code === 'open' ? 'abierto' : 'cerrado';
	}
	try {
		await this.$http.patch(`period/${this.periodId}/${this.code}`);
		this.showNotification(`El periodo contable ha sido ${message} correctamente.`);
		this.$emit('on-close');
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		}
	} finally {
		this.loading = false;
	}
}

function validations() {
	return {
		periodId: { required },
	};
}

function data() {
	return {
		loading: false,
		periodId: null,
		periods: [],
	};
}

export default {
	name: 'accounting-period-activate-form',
	components: {
		BaseSelect: () => import('@/components/shared/inputs/base-select'),
	},
	computed: {
		disabled,
	},
	created,
	data,
	methods: {
		loadPeriods,
		submitForm,
	},
	props: {
		code: String,
		subsidiaryId: [Number, String],
	},
	validations,
};
</script>



// WEBPACK FOOTER //
// src/components/accounting-periods/accounting-period-activate-form.vue